"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ManagerConfiger = (function () {
    function ManagerConfiger() {
    }
    ManagerConfiger.getInstance = function () {
        if (!ManagerConfiger.instance) {
            ManagerConfiger.instance = new ManagerConfiger();
        }
        return ManagerConfiger.instance;
    };
    ManagerConfiger.prototype.updatePublicRuntimeConfig = function (runtimeConfig) {
        if (runtimeConfig) {
            this.publicRuntimeConfig = runtimeConfig;
            this.updateDomain(this.publicRuntimeConfig.domain);
        }
    };
    ManagerConfiger.prototype.updateDomain = function (domainValue) {
        this.domainValue = domainValue;
    };
    Object.defineProperty(ManagerConfiger.prototype, "domain", {
        get: function () {
            return this.domainValue || 'operational';
        },
        enumerable: true,
        configurable: true
    });
    return ManagerConfiger;
}());
exports.default = ManagerConfiger.getInstance();
//# sourceMappingURL=ManagerConfiger.js.map